/* eslint-disable no-console,no-restricted-syntax */
import Vue from 'vue';
import App from './App.vue';
import Axios from 'axios'
import VueNoty from 'vuejs-noty'
import BootstrapVue from 'bootstrap-vue';
import VueSanitize from "vue-sanitize";
import * as microsoftTeams from "@microsoft/teams-js";
import * as constants from './constants.ts';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
import { registerLicense } from '@syncfusion/ej2-base';
Vue.use(SchedulePlugin);
registerLicense('ORg4AjUWIQA/Gnt2VFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5WdURiWX5acndRQ2ha');

import store from './store.js'; 
import router from './router'

Vue.use(BootstrapVue);
Vue.use(VueSanitize);
Vue.use(VueNoty, {
    theme: 'nest',
    timeout: 2000,
    progressBar: true,
    layout: 'bottomCenter'
});

const { DateTime, Interval } = require("luxon");

const compare = require('semver-compare');
Vue.prototype.$compare = compare;

Vue.prototype.$luxonDateTime = DateTime;
Vue.prototype.$luxonInterval = Interval;

Vue.prototype.$http = Axios;
Vue.prototype.microsoftTeams = microsoftTeams;
Vue.prototype.axios = Axios;
Vue.prototype.$const = constants;

Vue.filter('convertDateTime', value => {
    var offset = new Date().getTimezoneOffset();
    console.log(offset);
    return value;
});

import './sass/app.scss';
import i18n from './i18n';

Axios.defaults.withCredentials = true;

Axios.interceptors.request.use(function (config) {
    if(config.url.includes("/server/rest/"))
    {
        let lang = store.getters['lang/locale'];
        if(lang != undefined)
        {
            config.headers.common['x-lang'] = lang;
        }
        let token = store.getters['user/token'];
        //store.dispatch("user/logInfo", token);        
        if(token != "")
        {
            store.dispatch("user/logInfo", "token NOT found on user");        
        }
        if(token == undefined)
        {
            store.dispatch("user/logInfo", "token undefined");        
        }
        if(token != undefined)
        {
            if(token != "")
            {   
                store.dispatch("user/logInfo", "bearer token");                     
                config.headers.Authorization =  token ? `Bearer ${token}` : '';
            }
        }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });


Axios.interceptors.response.use(
    (response) => {        
        if(response.data.responseObject != undefined)
        {
            if(response.data.validations.validations.length != 0)
            {
                store.dispatch("errors/addValidations", response.data.validations.validations);
            }
            if(response.data.status == "Error"){
                return Promise.reject(new Error('fail_4_4'));           
            }            
            response.data = response.data.responseObject;
        }
        return response;        
    },
    (error) => {
        if (error.response.status === 400) {
            if(error.response.data.validations != undefined)
            {
                if(error.response.data.validations.validations.length != 0)
                {
                    console.log("error -> dispatch");
                     store.dispatch("errors/addValidations", error.response.data.validations.validations);
                }
                return Promise.reject(new Error('fail_4_4'));
            }            
        }
        if (error.response.status === 401) {                        
            localStorage.removeItem("token");
            store.dispatch('user/NotAuthenticated').then(() => {   
                router.push({ name: "Login" });
            });
        }
        if (error.response.status === 504) {
            window.location.href = "/server-not-responding";
        }
        if (error.response.status === 502) {
            window.location.href = "/server-not-responding";
        }
        return Promise.reject(error)
    }
);

import '@/mixins/generalMixin';


new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');